export default __webpack_public_path__ + "static/media/heads-geometry.69c662a1.jpg";